import { createStore, compose, applyMiddleware } from 'redux'
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant'
import thunk from 'redux-thunk'
import { createBrowserHistory } from 'history'
// 'routerMiddleware': the new way of storing route changes with redux middleware since rrV4.
import { routerMiddleware } from 'connected-react-router'
import { persistStore, persistReducer } from 'redux-persist'
import immutableTransform from 'redux-persist-transform-immutable'
import storage from 'redux-persist/lib/storage'
import rootReducer from '../reducers'

export const history = createBrowserHistory()

const persistConfig = {
  transforms: [immutableTransform()],
  key: 'root',
  storage,
}

const initialState = {}

const persistedReducer = persistReducer(persistConfig, rootReducer(history))

const reactRouterMiddleware = routerMiddleware(history)
const prodMiddlewares = compose(
  applyMiddleware(...[
    thunk,
    reactRouterMiddleware,
  ])
)

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose // add support for Redux dev tools
const devMidlewares = composeEnhancers(
  applyMiddleware(...[
    reduxImmutableStateInvariant(),
    thunk,
    reactRouterMiddleware
  ])
)

const middlewares = process.env.NODE_ENV === 'production' ? prodMiddlewares : devMidlewares

const configureStore = createStore(persistedReducer, initialState, middlewares)

export const persistor = persistStore(configureStore)

export default configureStore 